import ReactModal from "react-modal";
import styled from "styled-components";

export const Container = styled.form`
  h1 {
    font-weight: 600;
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
  }

  button {
    height: 4rem; /* Adjusted height */
    width: 25rem; /* Adjusted width */
    font-size: 1.5rem; /* Optional: Adjust font size */
    border-radius: 0.5rem; /* Optional: Adjust border radius */
  }
`;
export const StyledReactModal = styled(ReactModal)`
      position: absolute;
      top: 50%;
      left: 50%;
      right: auto;
      bottom: auto;
      margin: auto;
      transform: translate(-50%, -50%);
      font-size: 2rem;
      width: 68.5rem;
      border-radius: 2rem;
      background-color: white;
      @media (max-width:  768px) {
        width: 90%;
        height: auto;
      }
  @media (max-width: 1200px) {
 
    margin-left: 2rem;

  }

`;
